<template>
  <div class="s-experts-end-container">
    <div class="s-experts-end-filter-wrap">
      <div class="form-inline-wrap">
        <div class="flex-2">
          <span class="span-label">模糊搜索：</span>
          <el-input
            v-model="formInline.queryKey"
            placeholder=""
            class="input-width"
          ></el-input>
        </div>
        <div>
          <span class="span-label">问题状态：</span>
          <el-select v-model="formInline.state" placeholder="问题状态">
            <el-option label="未回答" value="0"></el-option>
            <el-option label="已回答" value="1"></el-option>
          </el-select>
        </div>
        <div>
          <span class="span-label">问题类型：</span>
          <el-select v-model="formInline.type" placeholder="问题类型">
            <el-option
              :label="itm.codeName"
              :value="itm.codeValue"
              v-for="(itm, ind) in typeList"
              :key="ind"
            ></el-option>
            <!-- <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </div>
      </div>
      <div class="form-inline-wrap">
        <div class="flex-2">
          <span class="span-label">起止时间：</span>
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="daterange-width"
            @change="dateChoose"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="{
              disabledDate(time) {
                // 设置禁用状态，参数为当前日期，要求返回 Boolean
                return time.getTime() > Date.now();
              },
            }"
          ></el-date-picker>
        </div>
        <div>
          <div class="query-btn" @click="serach">查询</div>
          <div class="reset-btn" @click="resetData">重置</div>
        </div>
      </div>
    </div>
    <div class="s-question-list-wrap" v-if="questionsDataList.length > 0">
      <div class="text-title">问题列表</div>
      <div
        class="s-question-list"
        v-for="(item, index) in questionsDataList"
        :key="index"
      >
        <div class="answer-questions-desc">
          <div class="questions-img">
            <el-image
              v-if="item.imgType == 'image'"
              :src="item.qimg"
              :preview-src-list="[item.qimg]"
              class="img"
            ></el-image>
            <!-- <img :src="item.qimg" class="img" alt /> -->
            <video
              v-if="item.imgType == 'video'"
              :src="item.qimg"
              class="img"
              controls
            ></video>
          </div>
          <div>
            <div class="questions-title">{{ item.qtitle }}</div>
            <div class="questions-type">
              <div>
                <span class="span-title">问题类型：</span>{{ item.qtypeValue }}
              </div>
              <div>
                <span class="span-title">提问人：</span
                >{{ item.createUserName }}
              </div>
              <div>
                <span class="span-title">时间：</span>{{ item.createTime }}
              </div>
            </div>
            <div class="questions-desc">
              <div class="questions-desc-title">问题描述：</div>
              {{ item.qinfo }}
              <!-- 需要种植一批金银眉红茶，最佳的海拔是多少z/需要种植一批金银眉红茶，最佳的海拔是多少?需要种植一批金银眉红茶，
              最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少需要种植一批金银眉红茶，最佳的海拔是多少z/需要种植一批金银眉红茶，
              最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少 -->
            </div>
          </div>
        </div>
        <div class="questions-notAnswer-flag" v-show="item.questionState == 0">
          未回答
        </div>
        <div class="questions-answer-flag" v-show="item.questionState == 1">
          已回答
        </div>
        <div class="questions-answer-btn" @click="goDialog(item)">回答</div>
        <div
          class="experts-reply-wrap"
          ref="replyWrap"
          v-if="item.fsQaInfoList != null"
        >
          <div
            class="experts-reply"
            v-for="(item1, a) in item.fsQaInfoList"
            :key="a"
          >
            <div class="experts-reply-title">回答:</div>
            <div class="answerTime">{{ item1.createTime || "--" }}</div>
            <span>{{ item1.createUserName || "--" }}</span
            >：<span>{{ item1.content || "--" }}</span>
          </div>
        </div>
        <div
          class="experts-reply experts-reply-noData"
          style="
            height: 170px;
            text-align: center;
            line-height: 170px;
            color: #666;
            font-size: 16px;
          "
          v-if="item.fsQaInfoList == null"
        >
          暂无数据!
        </div>
      </div>
    </div>
    <div class="s-question-list-wrap" v-if="questionsDataList.length == 0">
      <div class="text-title">问题列表</div>
      <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
    </div>
    <div class="s-transaction-pagination w1300 marginAuto" v-if="questionsDataList.length > 0">
      <el-pagination
        class="tab_pagination"
        background
        :page-size="pageSize"
        :current-page="currentPage"
        layout="prev, pager, next"
        @current-change="currentChange"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="dialog"
      :before-close="closeDialog"
      :close-on-click-modal="false"
    >
      <div class="question-container-container">
        <el-image
          v-if="questionObj.imgType == 'image'"
          :src="questionObj.qimg"
          :preview-src-list="[questionObj.qimg]"
          class="question-user-image"
        ></el-image>
        <video
          v-if="questionObj.imgType == 'video'"
          :src="questionObj.qimg"
          class="question-user-image"
          controls
        ></video>
        <!-- <img :src="questionObj.qimg" class="question-user-image" alt /> -->
        <div class="question-user-content">
          <div class="question-content-title">{{ questionObj.qtitle }}</div>
          <div class="question-content-form">
            <span class="label">问题类型：</span>
            <span class="value mr40">{{ questionObj.qtypeValue }}</span>
            <span class="label">提问人：</span>
            <span class="value mr40">{{ questionObj.createUserName }}</span>
            <span class="label">时间：</span>
            <span class="value">{{ questionObj.createTime }}</span>
          </div>
          <div class="question-content-desc">问题描述：</div>
          <div class="question-content-text">
            <p>{{ questionObj.qinfo }}</p>
          </div>
        </div>
      </div>
      <div class="experts-reply-title">回答</div>
      <div
        class="experts-reply-wrap"
        ref="replyWrap"
        v-if="questionArr != null"
      >
        <div
          class="experts-reply"
          v-for="(itemChild, idnn) in questionArr"
          :key="idnn"
        >
          <div class="answerTime">{{ itemChild.createTime || "--" }}</div>
          <span>{{ itemChild.createUserName || "--" }}</span
          >：<span>{{ itemChild.content || "--" }}</span>
        </div>
      </div>
      <div
        class="experts-reply experts-reply-noData"
        style="
          height: 170px;
          text-align: center;
          line-height: 170px;
          color: #666;
          font-size: 16px;
        "
        v-if="questionArr == null"
      >
        暂无数据!
      </div>
      <div class="addAsk">
        <input
          maxlength="60"
          v-model="askVal"
          :placeholder="'请输入回复内容'"
          type="text"
          @keyup.enter="expertAnsweringQuestion"
        />
        <span class="ask-more-button" @click="expertAnsweringQuestion">
          回答
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectListByType } from "../utils/api/specialistPerson";
import {
  getQuestionsListPage,
  expertAnsweringQuestion,
  getQaInfoList,
} from "../utils/api/personalCenter";
export default {
  name: "experts-end",
  data() {
    return {
      formInline: {
        queryKey: "",
        state: "0",
        type: "",
        date: [],
      },
      typeList: [],
      currentPage: 1, // 页码
      pageSize: 10, // 每页显示数量
      total: 0, // 总数,
      questionsDataList: [],
      askVal: "",
      questionArr: [],
      questionObj: {},
      clickId: "",
      dialog: false,
      defaultImg: require("../assets/image/dealmakers/default.png"),

      //视频语音
      roomId: 0,
      exportId: '',
      userId: '',
      line_type: '',
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    //问题下拉列表
    this.selectListByType();
    this.getQuestionsListPage();
  },
  methods: {
    //问题下拉列表
    async selectListByType() {
      let params = {
        codeType: "question_type",
      };
      let res = await selectListByType(params);
      if (res.data.code == 0) {
        this.typeList = res.data.data;
      }
    },
    dateChoose(e) {
      this.formInline.date = e;
    },
    //问题列表
    async getQuestionsListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        queryKey: this.formInline.queryKey,
        state: this.formInline.state,
        type: this.formInline.type,
        startTime: this.formInline.date[0],
        endTime: this.formInline.date[1],
      };
      let res = await getQuestionsListPage(params);
      if (res.data.code == 0) {
        this.questionsDataList = res.data.data.records;
        this.questionsDataList.forEach((item) => {
          if (item.qimg == "") {
            item.qimg = this.defaultImg;
          } else {
            if (item.qimg.includes("http")) {
              item.qimg = item.qimg.split(",")[0];
              if (
                item.qimg.split(".")[item.qimg.split(".").length - 1] == "mp4"
              ) {
                item.imgType = "video";
              } else {
                item.imgType = "image";
              }
            } else {
              item.qimg = this.imgURL + "/" + item.qimg.split(",")[0];
              if (
                item.qimg.split(".")[item.qimg.split(".").length - 1] == "mp4"
              ) {
                item.imgType = "video";
              } else {
                item.imgType = "image";
              }
            }
            console.log("this.qimg", this.qimg);
          }
        });
        this.total = res.data.data.total;
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    goDialog(obj) {
      this.dialog = true;
      this.clickId = obj.id;
      this.questionsDataList.forEach((item) => {
        if (this.clickId == item.id) {
          this.questionObj = item;
        }
        if (this.questionObj.qimg == "") {
          this.questionObj.qimg = this.defaultImg;
        } else {
          if (this.questionObj.qimg.includes("http")) {
            this.questionObj.qimg = this.questionObj.qimg.split(",")[0];
            if (
              this.questionObj.qimg.split(".")[
                this.questionObj.qimg.split(".").length - 1
              ] == "mp4"
            ) {
              this.questionObj.imgType = "video";
            } else {
              this.questionObj.imgType = "image";
            }
          } else {
            this.questionObj.qimg =
              this.questionObj.qimg + "/" + this.questionObj.qimg.split(",")[0];
            if (
              this.questionObj.qimg.split(".")[
                this.questionObj.qimg.split(".").length - 1
              ] == "mp4"
            ) {
              this.questionObj.imgType = "video";
            } else {
              this.questionObj.imgType = "image";
            }
          }
        }
      });
      this.getQaInfoList();
    },
    //详情
    async getQaInfoList() {
      console.log(" this.clickId", this.clickId);
      let params = {
        qaId: this.clickId,
      };
      let res = await getQaInfoList(params);
      if (res.data.code == 0) {
        this.questionArr = res.data.data;
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    //回答
    async expertAnsweringQuestion() {
      if(this.askVal == ''){
        return false
      }
      let data = {
        qaId: this.clickId,
        content: this.askVal,
        createUserId: localStorage.getItem("userInfo").userId,
        createUserName: localStorage.getItem("userInfo").userAccount,
      };
      let res = await expertAnsweringQuestion(data);
      if (res.data.code == 0) {
        this.$message.success(res.data.data);
        this.askVal = "";
        this.getQaInfoList();
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    closeDialog() {
      this.dialog = false;
      this.getQuestionsListPage();
    },
    //重置
    resetData() {
      this.formInline = {
        queryKey: "",
        state: "0",
        type: "",
        date: [],
      };
      this.currentPage = 1;
      this.getQuestionsListPage();
    },
    //查询
    serach() {
      this.currentPage = 1;
      this.getQuestionsListPage();
    },
    currentChange(value) {
      this.currentPage = value;
      this.getQuestionsListPage();
    },
    //更改pageSize
    pageSizeChange(value) {
      this.pageSize = value;
      this.getQuestionsListPage();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../utils/css/professionalInfoConsultation.scss";
</style>
<style lang="scss">
.el-dialog__body {
  overflow: hidden;
}
.s-experts-end-container{
  .el-empty__description{
		p{
			font-size: 16px;
		}
}
}

</style>
